/* eslint-disable react/prop-types */
import { Loader2 } from 'lucide-react';

const BiglocalLoader = ({ title }) => {
  return (
    <div className="fixed inset-0 z-50 bg-black/30 flex items-center justify-center backdrop-blur-md">
      <div className="bg-white rounded-2xl p-8 shadow-2xl flex flex-col items-center animate-in fade-in duration-300">
        <div className="relative">
          <Loader2 className="w-6 mx-auto h-6 animate-spin  text-green-600 mb-3" />
          <img src="/images/biglocallogo3.webp" className="w-32 h-auto animate-bounce" alt="logo" />
        </div>
        <p className="text-gray-700 line-clamp-1 font-medium mt-2">{title}</p>
        <div className="w-32 h-1 bg-gray-200 rounded-full mt-3 overflow-hidden">
          <div className="h-full bg-green-600 rounded-full animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};
export default BiglocalLoader;
